import { executeApiRequest } from './api-helpers'
import { IApiResponse, IApiCallOptions } from '@pushly/aqe/lib/interfaces'
import aqe from '@pushly/aqe'

export const fetchJobFilters = async (opts: IApiCallOptions): Promise<IApiResponse<any>> => {
    return await executeApiRequest<any>('get', `${aqe.defaults.publicApiDomain}/v3/jobs/filters`, null, opts, {
        data: {},
    })
}

export const fetchJobs = async (opts: IApiCallOptions): Promise<IApiResponse<any[]>> => {
    return await executeApiRequest<any[]>('get', `${aqe.defaults.publicApiDomain}/v3/jobs`, null, opts, { data: [] })
}

export const fetchJob = async (jobId: string, opts: IApiCallOptions): Promise<IApiResponse<any>> => {
    return await executeApiRequest<any>('get', `${aqe.defaults.publicApiDomain}/v3/jobs/${jobId}`, null, opts, {
        data: undefined,
    })
}

export const fetchJobOpsGenieId = async (jobId: string, opts: IApiCallOptions): Promise<IApiResponse<any>> => {
    return await executeApiRequest<any>(
        'get',
        `${aqe.defaults.publicApiDomain}/v3/jobs/${jobId}/opsgenie-id`,
        null,
        opts,
        { data: undefined },
    )
}

export const cloneJob = async (
    jobId: string,
    name: string | undefined,
    opts: IApiCallOptions,
): Promise<IApiResponse<any>> => {
    return await executeApiRequest<any>(
        'post',
        `${aqe.defaults.publicApiDomain}/v3/jobs/${jobId}/clone`,
        { name },
        opts,
        { data: undefined },
    )
}

export const forceFailJob = async (jobId: string, opts: IApiCallOptions): Promise<IApiResponse<any>> => {
    return await executeApiRequest<any>(
        'get',
        `${aqe.defaults.publicApiDomain}/v3/jobs/${jobId}/forced-fail`,
        null,
        opts,
        { data: undefined },
    )
}

export const fetchJobScheduleFilters = async (opts: IApiCallOptions): Promise<IApiResponse<any>> => {
    return await executeApiRequest<any>(
        'get',
        `${aqe.defaults.publicApiDomain}/v3/jobs/schedules/filters`,
        null,
        opts,
        { data: {} },
    )
}

export const createJobSchedule = async (schedule: any, opts: IApiCallOptions): Promise<IApiResponse<any>> => {
    return await executeApiRequest<any>('post', `${aqe.defaults.publicApiDomain}/v3/jobs/schedules`, schedule, opts, {
        data: {},
    })
}

export const fetchJobSchedules = async (opts: IApiCallOptions): Promise<IApiResponse<any[]>> => {
    return await executeApiRequest<any[]>('get', `${aqe.defaults.publicApiDomain}/v3/jobs/schedules`, null, opts, {
        data: [],
    })
}

export const fetchJobSchedule = async (scheduleId: number, opts: IApiCallOptions): Promise<IApiResponse<any>> => {
    return await executeApiRequest<any>(
        'get',
        `${aqe.defaults.publicApiDomain}/v3/jobs/schedules/${scheduleId}`,
        null,
        opts,
        { data: undefined },
    )
}

export const patchSchedule = async (
    scheduleId: string,
    patch: any,
    opts: IApiCallOptions,
): Promise<IApiResponse<any>> => {
    return await executeApiRequest<any>(
        'patch',
        `${aqe.defaults.publicApiDomain}/v3/jobs/schedules/${scheduleId}`,
        patch ?? {},
        opts,
        { data: undefined },
    )
}

export const silenceScheduleAlarms = async (scheduleId: string, opts: IApiCallOptions): Promise<IApiResponse<any>> => {
    return await executeApiRequest<any>(
        'get',
        `${aqe.defaults.publicApiDomain}/v3/jobs/schedules/${scheduleId}/alarms-silenced`,
        {},
        opts,
        { data: undefined },
    )
}

export const unsilenceScheduleAlarms = async (
    scheduleId: string,
    opts: IApiCallOptions,
): Promise<IApiResponse<any>> => {
    return await executeApiRequest<any>(
        'get',
        `${aqe.defaults.publicApiDomain}/v3/jobs/schedules/${scheduleId}/alarms-unsilenced`,
        {},
        opts,
        { data: undefined },
    )
}

export const destroySchedule = async (scheduleId: string, opts: IApiCallOptions): Promise<IApiResponse<any>> => {
    return await executeApiRequest<any>(
        'delete',
        `${aqe.defaults.publicApiDomain}/v3/jobs/schedules/${scheduleId}`,
        {},
        opts,
        { data: undefined },
    )
}
